export default __webpack_public_path__ + "static/media/sdg-5-load.f7f1d523.png";